import { render, staticRenderFns } from "./PublicMemoSets.vue?vue&type=template&id=5127b876&scoped=true"
import script from "./PublicMemoSets.vue?vue&type=script&lang=js"
export * from "./PublicMemoSets.vue?vue&type=script&lang=js"
import style0 from "./PublicMemoSets.vue?vue&type=style&index=0&id=5127b876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5127b876",
  null
  
)

export default component.exports